import SkeletonPulse from '@/context/ClipsContext/ClipSkeletonLoader/components/SkeletonPulse';

export default function PostSkeletonLoader() {
  return (
    <div className="flex size-full flex-col">
      <div className="flex w-full justify-between p-2 pt-4">
        <SkeletonPulse classname="h-9 w-40 rounded-md" />
        <div className="flex items-center space-x-3">
          <SkeletonPulse classname="size-9 rounded-md" />
          <SkeletonPulse classname="size-9 rounded-md" />
          <SkeletonPulse classname="w-20 h-9 rounded-md" />
        </div>
      </div>
      <div className="relative m-2 flex flex-1 rounded-md bg-white p-2.5">
        <SkeletonPulse classname="h-9 w-32 rounded-md" />
        <SkeletonPulse classname="absolute bottom-2 right-2 w-16 h-4 rounded-full" />
      </div>
    </div>
  );
}
